import Delegate from "ftdomdelegate";

import { hydrate } from "@/glow/events";
import {
  filtersUpdated,
  removeFilters,
  removeRange,
  filtersRemoved,
  rangeRemoved,
  everythingCleared,
} from "@/lib/filters/events";
import filtering from "@/lib/filters/filtering";

const filterHandler = ({ container, partial, renderCB }) => {
  let subscriptions = null;
  let filters = null;
  let delegate = null;

  filters = filtering(container);

  // Set initial evx state from collection url object
  hydrate(filters.getState());

  subscriptions = [
    filtersRemoved((_, { target }) => {
      filters.removeFilters(target, data => {
        renderCB(data.url);
        hydrate(data)();
      });
    }),

    rangeRemoved(() => {
      filters.removeRange(data => {
        renderCB(data.url);
        hydrate(data)();
      });
    }),

    filtersUpdated((_, { target }) => {
      filters.filtersUpdated(target, data => {
        renderCB(data.url);
        hydrate(data)();
      });
    }),

    everythingCleared(() => {
      filters.clearAll(data => {
        renderCB(data.url);
        hydrate(data)();
      });
    }),
  ];

  delegate = new Delegate(partial);

  delegate.on("click", "[data-remove-filter]", e => {
    e.preventDefault();
    removeFilters([e.target]);
  });

  delegate.on("click", "[data-remove-range]", e => {
    e.preventDefault();
    removeRange();
  });

  const unload = () => {
    delegate && delegate.off();
    subscriptions && subscriptions.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
};

export default filterHandler;
